var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-notification",class:{
    'inner-notification--loading': _vm.loading,
  }},[_c('span',{staticClass:"inner-notification__message"},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")]),(_vm.notification.buttonLabel)?_c('button',{ref:"button",staticClass:"inner-notification__button",attrs:{"type":"button"},on:{"click":_vm.notification.buttonAction}},[_vm._v(" "+_vm._s(_vm.notification.buttonLabel)+" "),_c('div',{staticClass:"inner-notification__loading-spinner"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }